import { combineReducers } from "redux";

import { sessionReducer } from "lcm-iot-commons";

const lastAction = (state: $TSFixMe, action: $TSFixMe) => action;

const rootReducer = combineReducers({
  lastAction,
  session: sessionReducer,
});

export default rootReducer;
